var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "today-button-section" }, [
    _c(
      "button",
      {
        staticClass: "button",
        attrs: { "aria-label": _vm.title, title: _vm.title },
        on: {
          click: function($event) {
            return _vm.today()
          }
        }
      },
      [_vm._v("\n\t\t" + _vm._s(_vm.$t("calendar", "Today")) + "\n\t")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }